{
  "validation": {
    "required": "Обов'язкове поле"
  },
  "ui": {
    "form": {
      "title": "Відновлення паролю",
      "subtitle": "Вам потрібно змінити пароль.",
      "password": {
        "label": "Новий пароль",
        "placeholder": "Створіть пароль",
        "message": "Мінімум 8 символів, одна велика і одна мала літера"
      },
      "confirmPassword": {
        "label": "Повторити пароль",
        "placeholder": "Ще раз для підтвердження"
      },
      "actions": {
        "submit": {
          "label": "Підтвердити",
          "loading": "Завантаження"
        }
      }
    }
  },
  "error": "Не вдається оновити пароль. Будь ласка, спробуйте пізніше.",
  "success": "Ваш акаунт було успішно оновлено",
  "toMainPage": "На головну"
}
